export default function enableScroll() {
  window.onscroll = function () {
    return null;
  };
  document.body.style.overflow = "";
}
